import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import ImageFader from './ImageFader'
import getImageUrl from '../utils/getImageUrl'
import { color, ease, bp, borderRadiusSmall } from '../globalStyles'

const HeaderTitle = styled.h1`
  position: relative;
  width: 75%;
  margin: 0;
  font-size: 3.4rem;
  line-height: 4rem;
  pointer-events: none;
  text-shadow: ${props =>
    props.shadow ? `0 1px 2px rgba(0,0,0,0.20)` : 'none'};

  ${props =>
    props.small &&
    css`
      margin: 0 auto;
      font-size: 2rem;
      font-weight: 700;
      text-align: center;
      line-height: 2.25rem;
    `};
`

const HeaderStyled = styled.header`
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
  color: inherit;
  padding: 1.4rem 2rem;
  display: flex;
  align-items: ${props => (props.small ? 'center' : 'flex-end')};
  border-bottom: 1px solid ${color.lightGrey};
  min-height: ${props => {
    if (props.large) return '26rem'
    if (props.imageHeader) return '20rem'
    return '5rem'
  }};

  ${props =>
    props.imageHeader &&
    css`
      background: ${color.black};
      color: white;
      position: relative;
    `};

  @media (${bp.desktop}) {
    position: relative;
    max-height: 60rem;
    width: 100%;
    max-width: 150rem;
    margin: 0 auto;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-radius: ${borderRadiusSmall};
    overflow: hidden;

    ${HeaderTitle} {
      font-size: 3.5rem;
      line-height: 1.2;
    }

    ${props =>
    props.imageHeader &&
      css`
        background: ${color.black};
        color: white;
        width: 90%;
        position: relative;
        font-size: 5.5rem;
        ${props => props.fitToContainer && 'max-width: 840px'};
        ${props => {
    if (props.large) return 'height: 45vw'
    if (props.small) return 'height: 20rem'
    return 'height: 45vw'
  }};
      `};
  }
`

const HeaderButton = styled.button`
  background: none;
  border: none;
  height: 3.5rem;
  width: 3.5rem;
  flex-shrink: 0;
  cursor: pointer;
  outline: none;
  will-change: transform;
  transition: transform 0.5s ${ease.popIn};
  position: absolute;
  right: 2rem;

  &:hover,
  &:focus {
    transform: scale(1.2);
  }

  svg {
    width: 100%;
    height: 100%;
    fill: white;

    @media (max-width: 365px) {
      height: 80%;
      width: 80%;
    }
  }
`

const Header = ({
  images,
  title,
  button,
  slider,
  fitToContainer,
  ...props
}) => {
  images =
    images &&
    images.map(obj => {
      return getImageUrl(obj, 1, { maxWidth: 1800 })
    })

  const imageHeader = !!images

  return (
    <HeaderStyled
      {...props}
      imageHeader={imageHeader}
      fitToContainer={fitToContainer}
    >
      {images && <ImageFader slider={slider} images={images} alt={title} />}
      {title && (
        <HeaderTitle small={props.small} shadow={imageHeader}>
          {title}
        </HeaderTitle>
      )}
      {button &&
        button.icon && (
          <HeaderButton>
            <button.icon onClick={button.onClick} />
          </HeaderButton>
        )}
    </HeaderStyled>
  )
}

Header.propTypes = {
  title: PropTypes.string,
  images: PropTypes.array,
  large: PropTypes.bool,
  button: PropTypes.object
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js